export const environment = {
  production: true,
  // apiUrl: 'https://api.cloudkcg.net/v1/',
  apiUrl: 'https://vm6.cloudkcg.net/pedroservice/v1/',
  // apiUrl: 'http://localhost:5007/v1/',
  API_KEY: 'RPZSM7CVZC8OA1ST2401',
  key: 1209913198915261,
  iv: 1917031993200031,
  auth_token: 'QGtDZzIwMjNfUHNfMTJ3eS4=',
};
